module.exports = __webpack_public_path__ + "static/media/product-list.8f6df674.webp";